import FanSubscribePage from "./FanSubscribePage";

export default FanSubscribePage;
